/* ============================================================
   Leilo "5 Reasons Why" LP — vanilla interactions (deferred).
   Scoped to .lp5. No cart code here: add-to-cart + drawer reuse
   the theme's native <product-form> element (product-form.js).
   No analytics injected: Shopify Web Pixels fire page_viewed /
   product_added_to_cart natively; we only re-broadcast intent.
   ============================================================ */
(function () {
  function init() {
    var root = document.querySelector('.lp5');
    if (!root) return;

    /* ---------- Subscribe & Save toggle (default ON) ---------- */
    var sw = document.getElementById('lp-ssSwitch');
    var labOnce = document.getElementById('lp-labOnce');
    var labSub = document.getElementById('lp-labSub');

    function applySS(on) {
      if (sw) sw.setAttribute('aria-checked', on ? 'true' : 'false');
      if (labSub) labSub.classList.toggle('is-on', on);
      if (labOnce) labOnce.classList.toggle('is-on', !on);

      document.querySelectorAll('.lp5 .pcard__price .now').forEach(function (el) {
        var v = on ? el.dataset.sub : el.dataset.once;
        if (v) el.textContent = v;
      });
      document.querySelectorAll('.lp5 .js-ss-note').forEach(function (el) {
        el.style.visibility = on ? 'visible' : 'hidden';
      });
      // Enable the Recharge selling_plan only when subscribing; disabled inputs aren't submitted -> one-time.
      document.querySelectorAll('.lp5 .js-sp').forEach(function (el) {
        el.disabled = !on;
      });
      var bb = document.querySelector('.lp5-buybar .js-buybar-price');
      if (bb) bb.innerHTML = on ? (bb.dataset.sub || '') : (bb.dataset.once || '');
    }

    if (sw) {
      sw.addEventListener('click', function () {
        applySS(sw.getAttribute('aria-checked') !== 'true');
      });
      applySS(sw.getAttribute('aria-checked') === 'true');
    }

    /* ---------- FAQ accordion ---------- */
    document.querySelectorAll('.lp5 .faq__item').forEach(function (item) {
      var q = item.querySelector('.faq__q');
      var a = item.querySelector('.faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
      });
    });

    /* ---------- Sticky mobile buy-bar ---------- */
    var buybar = document.querySelector('.lp5-buybar');
    var hero = document.getElementById('lp-top');
    var offer = document.getElementById('offer');
    if (buybar && hero && offer) {
      var updateBuybar = function () {
        if (window.innerWidth >= 760) { buybar.classList.remove('is-visible'); return; }
        var past = hero.getBoundingClientRect().bottom < 40;
        var o = offer.getBoundingClientRect();
        var inOffer = o.top < window.innerHeight && o.bottom > 0;
        buybar.classList.toggle('is-visible', past && !inOffer);
      };
      updateBuybar();
      window.addEventListener('scroll', updateBuybar, { passive: true });
      window.addEventListener('resize', updateBuybar);
    }

    /* ---------- Reveal on scroll ---------- */
    var reveals = document.querySelectorAll('.lp5 .reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* ---------- In-page smooth scroll for CTAs (#offer etc.) ---------- */
    document.querySelectorAll('.lp5 a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id && id.length > 1) {
          var t = document.querySelector(id);
          if (t) {
            e.preventDefault();
            t.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });

    /* ---------- Add to cart → Rebuy Smart Cart (single cart UI on the LP) ----------
       The Rebuy global embed is the cart experience here. We intercept the offer-card
       form submits in CAPTURE phase on document, so the theme's <product-form> handler
       (which opens the theme drawer, or redirects to /cart when the drawer is absent)
       never runs on this page. Rebuy auto-opens on cart mutations it observes; the
       explicit show() below is a guarded backstop — it only fires if the flyout
       didn't open on its own, so no double-fire/flicker. */
    function smartCartVisible() {
      var el = document.getElementById('rebuy-cart');
      return !!(el && el.classList.contains('is-visible'));
    }
    function ensureSmartCartOpen(opts) {
      opts = opts || {};
      var deadline = Date.now() + (opts.timeoutMs || 12000);
      (function attempt() {
        var sc = window.Rebuy && window.Rebuy.SmartCart;
        var ready = sc && typeof sc.show === 'function' && document.getElementById('rebuy-cart');
        if (ready) {
          if (!smartCartVisible()) { try { sc.show(); } catch (e) {} }
          // re-assert once — covers show() landing while the cart is mid-init
          setTimeout(function () {
            if (!smartCartVisible()) {
              try { sc.show(); } catch (e) {}
              if (opts.onFail) setTimeout(function () { if (!smartCartVisible()) opts.onFail(); }, 1200);
            }
          }, 900);
          return;
        }
        if (Date.now() < deadline) { setTimeout(attempt, 250); return; }
        // deadline: last-ditch show() if the SDK exists but DOM never appeared
        if (sc && typeof sc.show === 'function') { try { sc.show(); } catch (e) {} }
        if (opts.onFail) setTimeout(function () { if (!smartCartVisible()) opts.onFail(); }, 1200);
      })();
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.closest || !form.closest('.lp5 .pcard__form')) return;
      e.preventDefault();
      e.stopPropagation(); // theme's ProductForm submit handler never fires for LP cards

      var btn = form.querySelector('[type="submit"]');
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      var label = btn ? btn.querySelector('span') : null;
      var orig = label ? label.textContent : '';
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      if (label) label.textContent = 'Adding…';
      var errWrap = form.querySelector('.product-form__error-message-wrapper');
      if (errWrap) errWrap.setAttribute('hidden', '');

      // FormData carries id, quantity:1, and selling_plan only while the
      // Subscribe & Save toggle is ON (the .js-sp input is disabled otherwise).
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) {
            throw new Error(res.j.description || res.j.message || 'Could not add to cart.');
          }
          // Give Rebuy's own cart-change auto-open a beat, then ensure it is open.
          // If the SDK never becomes available, fall through to /cart so the
          // shopper is never left without a cart UI.
          setTimeout(function () {
            ensureSmartCartOpen({ timeoutMs: 10000, onFail: function () { window.location.href = '/cart'; } });
          }, 500);
        })
        .catch(function (err) {
          if (errWrap) {
            errWrap.removeAttribute('hidden');
            var msg = errWrap.querySelector('.product-form__error-message');
            if (msg) msg.textContent = err.message;
          }
        })
        .finally(function () {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
          if (label) label.textContent = orig;
        });
    }, true);

    /* Deep-link trigger: /pages/five-reasons-why?viewcart=true opens the Smart
       Cart on load (reliable regardless of Rebuy's native URL handling; useful
       for ads/email). No /cart fallback here — a plain page load shouldn't
       navigate visitors away if the SDK is slow. */
    if (/[?&]viewcart=true/i.test(window.location.search)) {
      ensureSmartCartOpen({ timeoutMs: 30000 });
    }

    /* ---------- Content-view signal (theme-native; no pixel added) ----------
       Shopify's Web Pixels already emit `page_viewed` for this page. We only
       re-broadcast a DOM event for any first-party listeners that opt in. */
    try {
      document.dispatchEvent(new CustomEvent('lp:content-view', {
        bubbles: true,
        detail: { page: 'five-reasons-why' }
      }));
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
